export const DateUtils = {
    addWeeks: (currentDate, weeks) => {
        if (!weeks) {
            weeks = 0
        }
        const result = new Date(currentDate); // Create a copy to avoid modifying the original date
        result.setDate(result.getDate() + Number(weeks) * 7);
        return result;
    },

    addMonths: (currentDate, months) => {
        if (!months) {
            months = 0
        }
        const result = new Date(currentDate); // Create a copy to avoid modifying the original date
        result.setMonth(result.getMonth() + Number(months));
        return result;
    },

    convertVNDateToDate: (dateString) => {
        if (!dateString || dateString.trim() === "") {
            return null; // Trả về null nếu chuỗi ngày là null hoặc trống
        }
    
        const [day, month, year] = dateString.trim().split('/');      // Tách ngày, tháng, năm
    
        // Tạo đối tượng Date với thứ tự year, month (0-based), day, hours, minutes, seconds
        return new Date(year, month - 1, day);
    }
}